import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { IonicModule } from "@ionic/angular";
import { DatePipe, DecimalPipe } from "@angular/common";
import { Store } from "@ngrx/store";
import { selectStudentById } from "src/app/students/ngrx/students.selectors";

@Component({
    selector: 'app-payment-item',
    templateUrl: './payment-item.component.html',
    styleUrls: ['./payment-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [IonicModule, DatePipe, DecimalPipe]
})
export class PaymentItemComponent {

  constructor(private store: Store<any>) { }

  readonly paymentId = input<number>(undefined);
  public today = new Date();
  paymentSignal = this.store.selectSignal(state => state.payments.entities[this.paymentId()]);
  studentSignal = computed(() => this.store.selectSignal(selectStudentById(this.paymentSignal()?.student_id))());

  convertToDate(dateString) {
    return new Date(dateString);
  }

}
